import _ from 'lodash'
import React from 'react'
import { connect } from 'react-redux'
import ES from 'shared_src/issueMapping/ESAS'

import { withLegacyRouter } from '../../../../../decorators'
import { IGAO } from '../../../../igao'
import * as Card from '../../../../shared/card'
import IssueQueuer from '../../../../shared/IssueQueuer'
import { CircularProgress } from '../../../../shared/NarusMaterial'

import * as Actions from './actions'
import ESASForm from './form'

const FHIR_RESOURCE_TYPE = 'ESAS'

class ESAS extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      open: true
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.resetForm = this.resetForm.bind(this)
  }

  componentDidMount () {
    this.resetForm()
  }

  handleSubmit (data) {
    const {
      params: { id: patientId },
      dispatch
    } = this.props
    const contextId = _.get(this.props, 'encounter.document.context_id')
    this.queueIssues(data)

    dispatch(
      Actions.updateESAS(data, patientId, contextId, FHIR_RESOURCE_TYPE)
    )
  }

  resetForm () {
    const contextId = _.get(this.props, 'encounter.document.context_id')
    const {
      params: { id: patientId },
      dispatch
    } = this.props

    dispatch(Actions.getESAS(patientId, contextId))
  }

  queueIssues (data) {
    const {
      params: { id: patientId },
      dispatch,
      practitionerId,
      encounter: { id: encounterId }
    } = this.props
    const iq = new IssueQueuer({
      dispatch,
      patientId,
      practitionerId,
      encounterId
    })

    iq.queueIssues({
      mapping: ES.esasIssueMapping,
      currentForm: data,
      existingForms: undefined
    })
  }

  render () {
    const { esas } = this.props
    return (
      <div className='main'>
        <Card.Card expandable>
          <Card.Header>
            <h2>ESAS +</h2>
          </Card.Header>

          <Card.ExpandableWrapper
            style={{ padding: '0 1rem 1rem' }}
          >
            {esas.loading
              ? (
                <CircularProgress />
              )
              : (
                <ESASForm
                  formKey='esasPlus'
                  onSubmit={this.handleSubmit}
                  initialValues={esas.data}
                  cancel={this.resetForm}
                />
              )}
          </Card.ExpandableWrapper>

        </Card.Card>

        <IGAO path='esas' />
      </div>
    )
  }
}
const mapStateToProps = redux => ({
  esas: redux.esas,
  encounter: redux.encounter?.encounter,
  patientId: redux?.globalVars?.params?.id,
  practitionerId: redux.auth.profile.sub
})

export default connect(mapStateToProps)(withLegacyRouter(ESAS))
